import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledBlock = styled(Grid)`
  display: grid;
  padding: 15px 16px;
  column-spacing: 16px;
  row-gap: 16px;
  angle: 0 deg;
  opacity: 1;
  background: ${colors.primary15};
  border: 1px solid ${colors.primary25};
  border-radius: 4px;

  & h5 {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: ${colors.primary900};
  }

  &:hover {
    background: ${colors.primary25};
  }
`;
export const StyledSingleBlock = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 15px 16px;
  column-spacing: 16px;
  row-gap: 16px;
  angle: 0 deg;
  opacity: 1;
  background: ${colors.primary15};
  border: 1px solid ${colors.primary25};
  border-radius: 4px;

  &:hover {
    background: ${colors.primary25};
  }
  &:active {
    background: ${colors.primary500};
    border-color: ${colors.primary500};
    & h5 {
      color: ${colors.white};
    }
    & svg {
      color: ${colors.white};
    }
  }

  & h5 {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: ${colors.primary900};
  }

  & div {
    display: flex;
    gap: 16px;
    height: 28px;
  }
`;
export const StyledChildBlock = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-spacing: 8px;
  row-gap: 8px;
  angle: 0 deg;
  opacity: 1;
  border-radius: 4px;
  border-bottom-width: 1px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 12px;
  background: ${colors.white};

  &:hover {
    background: ${colors.primary900};
    & p {
      color: ${colors.white};
    }
    & svg {
      color: ${colors.white};
    }
  }
  &:active {
    background: ${colors.primary600};
    & p {
      color: ${colors.white};
    }
    & svg {
      color: ${colors.white};
    }
  }

  & p {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: ${colors.primary900};
  }
`;
